export default "__VITE_ASSET__DwZgi1Ux__"